<template>
  <div>
    <b-modal 
      id="th-voucher-modal" 
      ref="th-voucher-modal-ref" 
      hide-footer 
      :title="title"
    >
      <div class="mb-5 mt-5">
        <p>Your tour E-Voucher will be available from approximately six weeks before your holiday departure date. Once available, your E-Voucher can be found by clicking on the orange “View Voucher” button within your itinerary or within your "Vouchers & Documents" section of ViewTrail and the ViewTrail App.</p>
        <p><strong>You will receive one E-Voucher for your tour and will not require any further tour vouchers or documentation before you depart.</strong></p>
        <p><strong>Where any additional tour documentation may be required, such as for flight or train tickets, these will be given to you locally by your driver/guide or a local representative.</strong></p>
        <p><strong>Your pick-up time for journeys throughout your tour will not be displayed on your E-Voucher as this will be advised locally by your driver/guide or a local representative at least the day before.</strong></p>
        <p>In case you have any voucher or documentation queries locally, you can contact the local tour operator at any time.  Their local contact details will be on your E-Voucher and are also shown within your Essential Tour Information.</p>
      </div>
    </b-modal>
  </div>
</template>
  
<script>
export default {
  name: 'TouringHubVoucher',
  props: {
    title: {
      type: String
    }
  },
  methods: {
    showModal() {
      this.$refs["th-voucher-modal-ref"].show();
    }
  },
}
</script>
  
  <style lang="scss">
  .places {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
  }
  .place-select {
    cursor: pointer;
  }
  .active-place {
    font-weight: bold;
  }
  </style>